import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getHomeIcons } from '../../../../api/home/queries/getHomeIcons';
import { IHomeIcon } from '../../../../interfaces/HomeIcon.interfaces';

export const useGetHomeIconsQuery = () => {
  return useQuery<IHomeIcon[], AxiosError>(['home-icons'], () => getHomeIcons());
};
